import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from '../../services/ajs-auth.service';
import { ChartsService } from '../../services/charts.service';
import { UiRouterState } from 'src/app/services/ajs-router-state.service';

declare var google: any;

function totalValues(values) {
  return _.reduce(values, (result, value) => result + value, 0);
}

function getPercentage(value: number, total: number, digits = 2) {
  if (+value === 0 || +total === 0) {
    return '0';
  }

  return ((value / total) * 100).toFixed(digits);
}
@Component({
  selector: 'mandae-home-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss']
})
export class IndicatorsComponent implements OnInit {

  bars = {
    onDate: { label: 'Entregues dentro do prazo', value: '' },
    overdue: { label: 'Entregues com atraso', value: '' },
    waiting: { label: 'Aguardando entrega', value: '' },
    other: { label: 'Outros *', value: '' },
    made: { label: 'Entregas realizadas', value: '' },
  };
  shipments: any;
  deliveries: any;
  totalShipments: any;
  deliveriesPercent: string;
  now = new Date();

  constructor(
    private state: UiRouterState,
    private charts: ChartsService,
    private auth: AuthService) { }

  ngOnInit() {

      this.charts.get(this.auth.getCurrentUser().id, { data: moment().toISOString() })
      .pipe(
        tap(response => {
          this.shipments = response.envios;
          const shipmentsValues = _.omit(this.shipments, ['clienteId', 'periodo']);
          this.totalShipments = totalValues(shipmentsValues);
          this.setDeliveries(this.shipments, this.totalShipments);
          this.setBarValues(this.deliveries);
          this.setBarMainValues(this.totalShipments);
          this.setCallbacks();
        }),
        catchError((err: HttpErrorResponse) => of({ status: err.statusText })),
      )
      .subscribe();

  }

  private setDeliveries(shipments, totalShipments) {
    const deliveryValues = _.pick(shipments, ['entregueDentroPrazo', 'entregueComAtraso']);
    this.deliveries = totalValues(deliveryValues);
    this.deliveriesPercent = getPercentage(this.deliveries, totalShipments);
  }

  private setBarValues(totalDeliveries) {
    this.bars['onDate'].value  = getPercentage(this.shipments.entregueDentroPrazo, totalDeliveries);
    this.bars['overdue'].value = getPercentage(this.shipments.entregueComAtraso, totalDeliveries);
  }

  private setBarMainValues(totalShipments) {
    this.bars['other'].value = getPercentage(this.shipments.outros, totalShipments);
    this.bars['waiting'].value = getPercentage(this.shipments.aguardandoEntrega, totalShipments);
    this.bars['made'].value = getPercentage(this.deliveries, totalShipments);
  }

  private setCallbacks() {
    google.charts.load('visualization', { packages: ['corechart', 'bar'] });
    google.charts.setOnLoadCallback(() => this.buildChart());
  }

  public buildChart() {
    const data = google.visualization.arrayToDataTable([
      ['Métrica', '', {role: 'style'}, {role: 'annotation'}],
      ['Outros *', this.shipments.outros, '#ffdd00', this.shipments.outros + ' (' + this.bars.other.value + '%)'],
      ['Aguardando entrega', this.shipments.aguardandoEntrega, '#FF6900',
        this.shipments.aguardandoEntrega + ' (' + this.bars.waiting.value + '%)'],
      ['Entregues', this.deliveries, '#6CC24A', this.deliveries + ' (' + this.bars.made.value + '%)'],
      ['Total de envios', this.totalShipments, '#00A9CE', this.totalShipments]
    ]);

    const options = {
      width: '100%',
      height: '100%',
      chartArea: {
        top: 0,
        width: '80%',
        height: '80%'
      },
      backgroundColor: '#FFFFFF',
      hAxis: { minValue: 0 },
      vAxis: { minValue: 0 },
      legend: { position: 'none' },
    };

    const chart = new google.visualization.BarChart(document.getElementById('packages'));
    chart.draw(data, options);
  }

  public goToIndicatorsPanel() {
    this.state.go('indicadores');
  }

}
